import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

/**
 * Wrapper around TanStack Query's useQuery hook
 * Provides a semantic API for fetching data (GET requests)
 *
 * @example
 * ```typescript
 * const teamService = new TeamService();
 * const { data, isLoading, error } = useFetch(
 *   teamService.getTeams()()
 * );
 * ```
 */
export function useFetch<
  TQueryFnData = unknown,
  TError = Error,
  TData = TQueryFnData,
  TQueryKey extends readonly unknown[] = readonly unknown[],
>(options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>): UseQueryResult<TData, TError> {
  return useQuery(options);
}
